export default __webpack_public_path__ + "static/media/Datenights-hover.c3a0a990.svg";